import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, ArrowRight } from 'lucide-react';

// Mock blog posts
const blogPosts = [
  {
    id: 1,
    title: 'As principais tendências em logística internacional para 2025',
    excerpt: 'Descubra as inovações que estão transformando o setor de comércio exterior e como sua empresa pode se beneficiar.',
    date: '15 Jan 2025',
    image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=600&q=80',
    category: 'Tendências',
  },
  {
    id: 2,
    title: 'Como otimizar custos no transporte marítimo',
    excerpt: 'Estratégias práticas para reduzir custos operacionais sem comprometer a qualidade do serviço.',
    date: '10 Jan 2025',
    image: 'https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=600&q=80',
    category: 'Dicas',
  },
  {
    id: 3,
    title: 'Novo acordo comercial entre Brasil e União Europeia',
    excerpt: 'Entenda os impactos do acordo Mercosul-UE para as operações de importação e exportação.',
    date: '05 Jan 2025',
    image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&q=80',
    category: 'Notícias',
  },
  {
    id: 4,
    title: 'Guia completo de documentos para exportação',
    excerpt: 'Tudo que você precisa saber sobre a documentação necessária para exportar seus produtos.',
    date: '28 Dez 2024',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=600&q=80',
    category: 'Guias',
  },
];

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-[#1a6b5c]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold italic text-white mb-4">
            Blog
          </h1>
          <p className="text-[#3ECDA3] text-lg">
            Notícias e insights sobre comércio exterior
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {blogPosts.map((post) => (
              <article
                key={post.id}
                className="group bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-[#3ECDA3] text-white text-xs font-medium px-3 py-1 rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-gray-500 text-sm mb-3">
                    <Calendar size={14} />
                    <span>{post.date}</span>
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#3ECDA3] transition-colors duration-300">
                    {post.title}
                  </h2>
                  <p className="text-gray-600 text-sm mb-4">
                    {post.excerpt}
                  </p>
                  <button className="inline-flex items-center gap-2 text-[#3ECDA3] font-medium text-sm hover:gap-3 transition-all duration-300">
                    Ler mais
                    <ArrowRight size={16} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
